import { useStorage } from '@vueuse/core';

const rate = useStorage('personal-speech-rate', 0.8);
export function useSpeechRate() {
    return {
        rate,
    };
}
